<template>
  <v-row>
    <v-col cols="12 py-0 pt-2 px-8">
      <h3>Thông tin SKU</h3>
    </v-col>
    <v-col cols="12" class="py-0 pt-4">
      <v-row>
        <v-col cols="6" class="py-0 px-8">
          <div class="d-flex">
            <v-btn
              class="btn-info"
              small
              @click="showCreateForm"
            >
              + Thêm SKU
            </v-btn>

            <v-btn
              class="btn-save mx-0"
              small
              @click="handleEditAll"
            >
              Chỉnh sửa hàng loạt
            </v-btn>
            <v-btn
              class="btn-save-all mx-3"
              small
              v-if="checkShowSaveAll()"
              @click="handleSaveAll"
            >
              Lưu hàng loạt
            </v-btn>
          </div>
        </v-col>
        <v-col cols="6" class="py-0 px-8 justify-end d-flex">
          <v-row>
            <v-col offset="6" cols="6" class="py-0">
              <v-text-field
                class="text-search"
                outlined
                dense
                placeholder="Nhập tên SKU"
                @keyup="searchSkuOffline"
                v-model="txtSkuName"
              >
                <v-icon
                  class="icon-search"
                  slot="prepend"
                  color="#adadad"
                >
                  mdi-magnify
                </v-icon>
              </v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col class="py-0 px-8 pb-3 table-product" cols="12" >
        <v-simple-table class="table-layout table-custom table-sku">
          <thead>
            <tr>
              <th class="col-code">Mã SKU</th>
              <th class="col-name">Tên SKU*</th>
              <th class="col-name-card">Tên trên thẻ học*</th>
              <th class="col-name-card">Mã Combo LMS*</th>
              <th class="col-price">Giá*</th>
              <th class="col-subject">Môn*</th>
              <th class="col-level">Trình độ</th>
              <th class="col-grade">Khối lớp*</th>
              <th class="col-activation">Phương thức kích hoạt*</th>
              <th class="col-duration-type">Loại thời hạn*</th>
              <th class="col-end-date text-center">Thời hạn*</th>
              <th class="col-status">Trạng thái*</th>
              <th class="col-transaction">Giao dịch*</th>
              <th class="col-action text-center">Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!skuItems.length">
              <td colspan="12">
                Không có dữ liệu
              </td>
            </tr>
            <template v-if="skuItems.length">
                <validation-observer ref="validator" v-for="(item, index) in skuItems" tag="tr" :key="index" @dblclick="handleEditRow(item)">
                                <td><span>{{ item.code || '__' }}</span>
                                </td>
                                <td :class="[ item.isEdit ? 'pt-6': '' ]">
                                    <template v-if="item.isEdit">
                                        <validation-provider v-slot="{ errors }" :rules="{ required: true}" name="Tên SKU" :vid="`name+${index}`">
                                            <v-text-field
                                                    class="text-field"
                                                    :error-messages="errors"
                                                    outlined
                                                    dense
                                                    maxLength="100"
                                                    :name="'name'+index"
                                                    placeholder="Nhập tên SKU"
                                                    v-model="item.name"
                                            />
                                        </validation-provider>
                                    </template>
                                    <span v-else>{{ item.name }}</span>
                                </td>
                                <td :class="[ item.isEdit ? 'pt-6': '' ]">
                                    <template v-if="item.isEdit">
                                        <validation-provider v-slot="{ errors }" :rules="{ required: true }" name="Tên trên thẻ học" :vid="`name-card+${index}`">
                                            <v-text-field
                                                    class="text-field"
                                                    :error-messages="errors"
                                                    outlined
                                                    dense
                                                    maxLength="50"
                                                    :name="'name'+index"
                                                    placeholder="Nhập tên trên thẻ học"
                                                    v-model="item.cardDisplayName"
                                            />
                                        </validation-provider>
                                    </template>
                                    <span v-else>{{ item.cardDisplayName }}</span>
                                </td>
                                <td :class="[ item.isEdit ? 'pt-6': '' ]">
                                    <template v-if="item.isEdit">
                                        <validation-provider v-slot="{ errors }" :rules="{ required: true }" name="Mã Combo LMS" :vid="`lmsCodes + ${index}`">
                                            <v-autocomplete
                                                class="text-field"
                                                :error-messages="errors"
                                                :clearable="true"
                                                :items="lmsCodes"
                                                item-value="code"
                                                item-text="code"
                                                :aLight="'right'"
                                                placeholder="Chọn"
                                                attach
                                                multiple
                                                outlined
                                                dense
                                                v-model="item.lmsCodes"
                                                :menu-props="{ bottom: true, offsetY: true, maxHeight: '200' }"
                                            />
                                        </validation-provider>
                                    </template>
                                    <span v-else>{{ item.lmsCodes.join(', ') }}</span>
                                </td>
                                <td :class="[ item.isEdit ? 'pt-6': '' ]">
                                    <template v-if="item.isEdit">
                                        <validation-provider v-slot="{ errors }" :rules="{ required: true, max: 10}" name="Giá" :vid="`orgPrice + ${index}`">
                                            <v-text-field
                                                    class="text-field text-field-number"
                                                    :error-messages="errors"
                                                    outlined
                                                    dense
                                                    placeholder="Nhập giá"
                                                    type="number"
                                                    min="0"
                                                    name="orgPrice"
                                                    @input="item.orgPrice= item.orgPrice.replace(/[^0-9\.]/g,'');"
                                                    v-model="item.orgPrice"
                                            >
                                            </v-text-field>
                                        </validation-provider>
                                    </template>
                                    <span v-else>{{  item.orgPrice ? formatPrice(item.orgPrice)+' đ' : '0 đ' }}</span>
                                </td>
                                <td :class="[ item.isEdit ? 'pt-6': '' ]">
                                    <template v-if="item.isEdit">
                                        <validation-provider v-slot="{ errors }" :rules="{ required: true}" name="Môn" :vid="`subjectId + ${index}`">
                                            <v-select
                                                    class="text-field"
                                                    :error-messages="errors"
                                                    :clearable="true"
                                                    :items="subjects"
                                                    item-value="id"
                                                    item-text="name"
                                                    :aLight="'right'"
                                                    placeholder="Chọn"
                                                    attach
                                                    outlined
                                                    dense
                                                    v-model="item.subjectId"
                                                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '200' }"
                                            />
                                        </validation-provider>
                                    </template>
                                    <span v-else>{{ subjectsObj[item.subjectId] }}</span>
                                </td>
                                <td :class="[ item.isEdit ? 'pt-6': '' ]">
                                    <template v-if="item.isEdit">
                                        <v-select
                                                class="text-field"
                                                :clearable="true"
                                                :items="curriculumTypes"
                                                item-value="id"
                                                item-text="name"
                                                :aLight="'right'"
                                                placeholder="Chọn"
                                                attach
                                                outlined
                                                dense
                                                v-model="item.level"
                                                :menu-props="{ bottom: true, offsetY: true, maxHeight: '200' }"
                                        ></v-select>
                                    </template>
                                    <span v-else>
                        {{ item.level ? curriculumTypesObj[item.level] : "--" }}
                    </span>
                                </td>
                                <td :class="[ item.isEdit ? 'pt-6': '' ]">
                                    <template v-if="item.isEdit">
                                        <validation-provider v-slot="{ errors }" class="mb-2" :rules="{ required: true}" name="Khối lớp"  :vid="`gradeIds + ${index}`">
                                            <v-select
                                                    class="text-field"
                                                    :error-messages="errors"
                                                    :clearable="true"
                                                    :items="grades"
                                                    item-value="id"
                                                    item-text="name"
                                                    :aLight="'right'"
                                                    placeholder="Chọn"
                                                    attach
                                                    outlined
                                                    dense
                                                    multiple
                                                    v-model="item.gradeIds"
                                                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '200' }"
                                            ></v-select>
                                        </validation-provider>
                                    </template>
                                    <template v-else>
                                        {{ showGradeTitle(item.gradeIds) }}
                                    </template>
                                </td>
                                <td :class="[ item.isEdit ? 'pt-6': '' ]">
                                    <template v-if="item.isEdit">
                                        <validation-provider v-slot="{ errors }" :rules="{ required: true}" name="Phương thức kích hoạt"  :vid="`activationType + ${index}`">
                                            <v-select
                                                    class="text-field"
                                                    :error-messages="errors"
                                                    :clearable="true"
                                                    :items="skuActivation"
                                                    item-value="id"
                                                    item-text="name"
                                                    :aLight="'right'"
                                                    placeholder="Chọn"
                                                    attach
                                                    outlined
                                                    multiple
                                                    dense
                                                    v-model="item.activationTypes"
                                                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '200' }"
                                            />
                                        </validation-provider>
                                    </template>
                                    <template v-else>
                                        {{ item.activationTypes.map(item => skuActivationObj[item]).join(', ') }}
                                    </template>
                                </td>
                                <td :class="[ item.isEdit ? 'pt-6': '' ]">
                                    <template v-if="item.isEdit">
                                        <validation-provider v-slot="{ errors }" :rules="{ required: true}" name="Loại thời hạn"  :vid="`durationType + ${index}`">
                                            <v-select
                                                    class="text-field"
                                                    :error-messages="errors"
                                                    :clearable="true"
                                                    :items="durationType"
                                                    item-value="id"
                                                    item-text="name"
                                                    :aLight="'right'"
                                                    placeholder="Chọn"
                                                    attach
                                                    outlined
                                                    dense
                                                    :disabled="item.id ? true : false"
                                                    v-model="item.durationType"
                                                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '200' }"
                                            ></v-select>
                                        </validation-provider>
                                    </template>
                                    <template v-else>
                                        {{ durationTypeObj[item.durationType] }}
                                    </template>
                                </td>
                                <td :class="[ item.isEdit ? 'pt-6': '', 'text-center' ]">
                                    <template v-if="item.isEdit">
                                        <validation-provider v-if="item.durationType == 'month'" v-slot="{ errors }" :rules="{ required: true, max: 10}" name="Thời hạn"  :vid="`endDate-day${index}`">
                                            <v-text-field
                                                    class="text-field text-field-number"
                                                    :error-messages="errors"
                                                    outlined
                                                    dense
                                                    min="0"
                                                    @input="item.duration= item.duration.replace(/[^0-9\.]/g,'');"
                                                    placeholder="Nhập số"
                                                    v-model="item.duration"
                                                    type="number"
                                                    v-if="item.durationType == 'month'"
                                            >
                                            </v-text-field>
                                        </validation-provider>
                                        <template v-if="item.durationType == 'day'">
                                            <v-menu
                                                    ref="datePickerMenu"
                                                    v-model="datePickerMenu[showPopupDate(item)]"
                                                    :close-on-content-click="false"
                                                    :return-value.sync="item.endDate"
                                                    transition="scale-transition"
                                                    offset-y
                                                    max-width="290px"
                                                    min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <validation-provider
                                                            v-slot="{ errors }"
                                                            name="Thời hạn"
                                                            :rules="{required: item.durationType == 'day' }"
                                                            :immediate="false"
                                                            :vid="`endDate-day${index}`"
                                                    >
                                                        <v-text-field
                                                                style="width: 190px !important;"
                                                                placeholder="Chọn ngày"
                                                                v-model="item.endDate"
                                                                class="text-field"
                                                                :error-messages="errors"
                                                                readonly
                                                                outlined
                                                                prepend-icon="mdi-calendar-outline"
                                                                dense
                                                                v-on="on"
                                                                clearable
                                                        />
                                                    </validation-provider>
                                                </template>
                                                <v-date-picker
                                                        v-model="item.endDate"
                                                        scrollable
                                                        :min="currentDate"
                                                        @change="changeDate(item)"
                                                >
                                                </v-date-picker>
                                            </v-menu>
                                        </template>
                                    </template>
                                    <template v-else>
                                        {{ item.durationType == 'day' ? (item.endDate ? formatDate(item.endDate): '') : item.duration }}
                                    </template>
                                </td>
                                <td :class="[ item.isEdit ? 'pt-6': '', ]">
                                    <template v-if="item.isEdit">
                                        <validation-provider
                                                v-slot="{ errors }"
                                                :rules="{ required: true}"
                                                name="Trạng thái"
                                                :vid="`status + ${index}`">
                                            <v-select
                                                    class="text-field"
                                                    :error-messages="errors"
                                                    :clearable="true"
                                                    :items="skuStatus"
                                                    item-value="id"
                                                    item-text="name"
                                                    :aLight="'right'"
                                                    placeholder="Chọn"
                                                    attach
                                                    outlined
                                                    dense
                                                    v-model="item.status"
                                                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '200' }"
                                            ></v-select>
                                        </validation-provider>
                                    </template>
                                    <template v-else>
                                        {{ skuStatusObj[item.status] }}
                                    </template>
                                </td>
                                <td :class="[ item.isEdit ? 'pt-6': '' ]">
                                    <template v-if="item.isEdit">
                                        <validation-provider
                                                v-slot="{ errors }"
                                                :rules="{ required: true}"
                                                name="Giao dịch"
                                                :vid="`transactionStatus + ${index}`">
                                            <v-select
                                                    class="text-field"
                                                    :error-messages="errors"
                                                    :clearable="true"
                                                    :items="skuTransaction"
                                                    item-value="id"
                                                    item-text="name"
                                                    :aLight="'right'"
                                                    placeholder="Chọn"
                                                    attach
                                                    outlined
                                                    dense
                                                    v-model="item.transactionStatus"
                                                    :menu-props="{ bottom: true, offsetY: true, maxHeight: '200' }"
                                            ></v-select>
                                        </validation-provider>
                                    </template>
                                    <template v-else>
                                        {{ skuTransactionObj[item.transactionStatus] }}
                                    </template>
                                </td>
                                <td class="text-center">
                                    <div class="d-flex align-center justify-center">
                                        <div v-show="item.isEdit && !item.id && !productId">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon @click="handleSubmitData(item,index)" class="cursor-pointer"  color="#002E86" v-on="on">
                                                        mdi-content-save
                                                    </v-icon>
                                                </template>
                                                <span>Save draft</span>
                                            </v-tooltip>
                                        </div>
                                        <div v-show="item.isEdit && productId">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon @click="handleSubmitData(item, index)" class="cursor-pointer"  color="#329D20" v-on="on">
                                                        mdi-check-circle
                                                    </v-icon>
                                                </template>
                                                <span> {{ item.id  ? 'Update' : 'Create'}}</span>
                                            </v-tooltip>
                                        </div>
                                        <div v-show="productId" >
                                            <v-tooltip v-if="productId" bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon v-on="on" @click="cloneSKU(item)" class="ml-3 cursor-pointer" color="#4048FF">
                                                        mdi-plus-circle-outline
                                                    </v-icon>
                                                </template>
                                                <span>Clone SKU</span>
                                            </v-tooltip>
                                        </div>
                                        <div v-show="!item.id">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon v-on="on" class="ml-3 cursor-pointer" color="#959595" @click="deleteSku(item, index)">
                                                        mdi-delete
                                                    </v-icon>
                                                </template>
                                                <span>Xóa SKU</span>
                                            </v-tooltip>
                                        </div>
                                        <v-tooltip bottom v-if="item.id">
                                            <template v-slot:activator="{ on }">
                                                <a :href="`${detailSkuLink(item, index)}`" rel="noopener noreferrer" @click.prevent>
                                                    <v-icon v-on="on" class="ml-3 cursor-pointer" color="#959595" @click="detailSku(item, index)">
                                                        mdi-sale
                                                    </v-icon>
                                                </a>
                                            </template>
                                            <span>Chính sách</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                </validation-observer>
            </template>
            <tr v-if="skuItems.length < 4" class="tr-no-data"><td colspan="12"></td></tr>
          </tbody>
        </v-simple-table>
    </v-col>
  </v-row>
</template>

<script>
import * as moment from 'moment';

import SkuDuo from '../../models/SkuDuo';
import {formatDate} from "@/helpers/utils";

import RepositoryFactory from '@/repositories/RepositoryFactory';
const OrderRepository = RepositoryFactory.get('order');

export default {
    name: 'duo-sku-list',
    components: {},
    props: {
        skuItems: {
            type: Array,
            default: () => [],
        },
        productAttributes: {
            type: Object,
            default: () => {
            },
        },
        productId: {
            type: Number,
            default: () => null,
        },
        isCreateData: {
            type: Boolean,
            default: false
        },
        isUpdateDone: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            datePickerMenu: [],
            tab: 0,
            isShowSku: false,
            newSku: new SkuDuo({}),
            subjects: [],
            subjectsObj: {},
            curriculumTypes: [],
            curriculumTypesObj: {},
            grades: [],
            gradesObj: {},
            skuActivation: [],
            skuActivationObj: {},
            durationType: [],
            durationTypeObj: {},
            skuStatus: [],
            skuStatusObj: {},
            skuTransaction: [],
            lmsCodes: [],
            skuTransactionObj: {},
            txtSkuName: null,
            errorEndDate: false,
            isEditAll: false,
            skuItemsClone: [],
        };
    },
    computed: {
        currentDate() {
            return moment().add(1, "days").format('YYYY-MM-DD')
        },
    },
    async created() {
        this.subjects = this.productAttributes.subjects;
        this.productAttributes.subjects.forEach((item) => {
            this.subjectsObj[item.id] = item.name;
        });

        this.curriculumTypes = this.productAttributes.curriculumTypes;
        this.productAttributes.curriculumTypes.forEach((item) => {
            this.curriculumTypesObj[item.id || item.code] = item.name;
        });

        this.grades = this.productAttributes.grades;
        this.productAttributes.grades.forEach((item) => {
            this.gradesObj[item.id || item.code] = item.name;
        });

        this.skuActivation = this.productAttributes.skuActivation;
        this.productAttributes.skuActivation.forEach((item) => {
            this.skuActivationObj[item.id || item.code] = item.name;
        });

        this.durationType = this.productAttributes.durationType;
        this.productAttributes.durationType.forEach((item) => {
            this.durationTypeObj[item.id || item.code] = item.name;
        });

        this.skuStatus = this.productAttributes.skuStatus;
        this.productAttributes.skuStatus.forEach((item) => {
            this.skuStatusObj[item.id || item.code] = item.name;
        });

        this.skuTransaction = this.productAttributes.skuTransaction;
        this.productAttributes.skuTransaction.forEach((item) => {
            this.skuTransactionObj[item.id || item.code] = item.name;
        });
        this.getLmsCodes();
    },
    mounted() {
        
    },
    beforeDestroy() {
    },
    watch: {
        isUpdateDone(val) {
            if (val) {
                this.skuItemsClone = _.cloneDeep(this.skuItems)
                this.isUpdateDone = false
            }
        }
    },
    methods: {
        showPopupDate(item) {
            const data = this.skuItems.filter(data => data.durationType == 'day' && data.isEdit)
            return data.indexOf(item)

        },
        changeDate(item) {
            const indexData = this.showPopupDate(item)
            console.log(this.$refs.datePickerMenu, indexData);
            this.$refs.datePickerMenu[indexData].save(item.endDate)
            this.datePickerMenu[indexData] = false
        },
        makeData(item) {
            const listData = {
                data: {
                    skuItem: {
                        name: item.name ? item.name.trim() : '',
                        cardDisplayName: item.cardDisplayName ? item.cardDisplayName.trim() : '',
                        orgPrice: item.orgPrice ?? null,
                        subjectId: item.subjectId ?? null,
                        level: item.level ?? null,
                        gradeIds: item.gradeIds ?? null,
                        activationTypes: item.activationTypes ?? null,
                        durationType: item.durationType ?? null,
                        status: item.status ?? null,
                        transactionStatus: item.transactionStatus ?? null,
                        code: item.code ?? null,
                        lmsCodes: item.lmsCodes ?? [],
                    }
                }
            }
            if (item.durationType === 'month') {
                listData.data.skuItem.duration = item.duration
            } else {
                listData.data.skuItem.endDate = item.endDate
            }
            return listData
        },
        async handleSubmitData(item, index) {
            const valid = await this.$refs.validator[index].validate()
            if (!valid) {
                return
            } else {
                if(this.productId) {
                    const changeData = this.skuItemsClone.find(data => data.id === item.id)
                    if (changeData && changeData.orgPrice !== Number(item.orgPrice) && item.id) {
                        this.$swal({
                            title: "Khi cập nhật lại giá cần thực hiện cài đặt lại chính sách giá. Bạn có chắc chắn muốn thực hiện thay đổi?",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Xác nhận",
                            cancelButtonText: "Hủy",
                        }).then(async (result) => {
                            if (result.value) {
                                const data = this.makeData(item)
                                this.$emit('onUpdateRow', item, {
                                    skuId: item.id,
                                    ...data
                                })
                            }
                        });
                    } else {
                        const data = this.makeData(item)
                        this.$emit('onUpdateRow', item, {
                            skuId: item.id,
                            ...data
                        })
                    }
                    console.log(item);
                    if (!item.id) {
                    const data = this.makeData(item)
                      this.$emit('onCreateRow', data)
                    }
                }else {
                    item.gradeIds.sort(this.compareByVal)
                    item.isEdit= false
                    delete item.id
                    delete item.code
                }
            }
        },
        searchSkuOffline: _.debounce(function (item, index, type = null) {
            this.$emit('searchSkuOffline', this.txtSkuName.trim());
        }, 500),
        showCreateForm() {
            this.$emit('onCreateSKU')
        },
        handleEditRow(item) {
           this.skuItemsClone = _.cloneDeep(this.skuItems)
           this.$emit('onEditRow', item)
        },
        cloneSKU(item) {
            this.$emit('onCloneSKU', item)
        },
        deleteSku(item, index) {
            if (!item.id) {
                this.$swal
                    .fire({
                        title: "Bạn muốn đóng form? Tất cả thông tin sẽ bị mất!",
                        icon: "warning",
                        showCancelButton: true,
                        cancelButtonText: "Hủy",
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Đồng ý",
                    })
                    .then(async (result) => {
                        if (result?.value) {
                            this.skuItems.splice(index, 1);
                        }
                    });
            }else {
                item.name =  item.originalName
                item.orgPrice = item.originalOrgPrice
                item.subjectId = item.originalSubjectId
                item.gradeIds = item.originalGradeIds
                item.durationType = item.originalDurationType
                item.cardDisplayName = item.originalCardDisplayName
                item.status = item.originalStatus
                item.level = item.originalLevel
                item.endDate = item.originalEndDate
                item.duration = item.originalDuration
                item.transactionStatus = item.originalTransactionStatus

            }
        },
        handleEditAll() {
            this.isEditAll= !this.isEditAll
            if(this.isEditAll) {
                this.skuItemsClone = _.cloneDeep(this.skuItems)
                this.skuItems.forEach(item => {
                    item.endDate = item.endDate ? formatDate(item.endDate) : ''
                    item.isEdit = true
                    return item
                })
            }else {
                this.skuItems.forEach(item => {
                    item.isEdit = false
                    return item
                })
            }
        },
        showGradeTitle(gradeIds) {
            let title = '';
            gradeIds.forEach((item) => {
                title += `${this.gradesObj[item]}, `;
            });

            return title ? title.slice(0, -2) : '';
        },
        compareByVal(a, b) {
            return a - b;
        },
        detailSku(item) {
            this.$router.push({
                path: `/products/${this.productId}/sku/${item.id}`,
                query: {
                    sku_type: 'duo',
                },
            });
        },
        detailSkuLink(item) {
			return `/products/${this.productId}/sku/${item.id}?sku_type=duo`;
		},
        async getLmsCodes() {
            const res = await OrderRepository.getListLmsCodes();
            if (res && res.data) {
                this.lmsCodes = res.data;
            }
        },
        checkShowSaveAll() {
            const data = _.cloneDeep(this.skuItems)
            if (data.filter(item => item.isEdit).length > 1) {
                return true
            }
            return false
        },
        async handleSubmitDataEditAll(item, index) {
          const valid = await this.$refs.validator[index].validate()
          if (!valid) {
              return
          } else {
              if (this.productId) {              
                if (!item.id) {
                    const data = this.makeData(item)
                    this.$emit('onCreateRow', data)
                } else {
                    const data = this.makeData(item)
                    delete data.data.skuItem.id
                        this.$emit('onUpdateRow', item, {
                            skuId: item.id,
                            ...data
                    })
                }
              } else {
                item.isEdit= false
              }
          }
        },
        async handleSaveAll() {
            let haveEditPrice = await this.skuItemsClone.some((item) => {
            let data = this.skuItems.find((data) => data.id === item.id)
                return data && Number(data.orgPrice) !== item.orgPrice
            })
            if (haveEditPrice) {
                this.$swal({
                    title: "Khi cập nhật lại giá cần thực hiện cài đặt lại chính sách giá. Bạn có chắc chắn muốn thực hiện thay đổi?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Xác nhận",
                    cancelButtonText: "Hủy",
                }).then(async (result) => {
                    if (result.value) {
                        await this.skuItems.forEach((item, index) => {
                            if (item.isEdit) {
                            this.handleSubmitDataEditAll(item, index)
                            }
                        })
                    } else {
                        this.skuItems.forEach((item, index) => {
                        let changeData = this.skuItemsClone.find((data) => data.id === item.id)
                        if (changeData && changeData.orgPrice === Number(item.orgPrice)){
                            this.handleSubmitDataEditAll(item, index)
                        }
                        })
                    }
                });
            } else {
                await this.skuItems.forEach((item, index) => {
                    if (item.isEdit) {
                    this.handleSubmitDataEditAll(item, index)
                    }
                })
            }
        },
    }
}
</script>
<style scoped lang="scss">
  .edit-data {
    vertical-align: top;
    padding-top: 24px !important;
  }
  .btn-save {
    background: #8465FF !important;
    color: #fff;
  }
  .btn-cancel  {
    background: #787878 !important;
    color: #fff;
  }

  .btn-info {
    background: #6587FF !important;
    color: #fff;
  }

  .icon-search {
    left: 40px;
    position: relative;
  }
  .table-custom {
    th {
      background: #E7E8FF;
      border-left: 1px solid #fff;
    }
  }
  .col-code {
    max-width: 150px;
    min-width: 150px;
  }
  .col-name {
    min-width: 300px;
    max-width: 300px;
  }

  .col-name-card {
    min-width: 300px;
    max-width: 300px;
  }

  .col-price {
    max-width: 200px;
    min-width: 200px;
  }
  .col-subject {
    max-width: 250px !important;
    min-width: 250px !important;
  }
  .col-level {
    max-width: 200px;
    min-width: 200px;
  }
  .col-grade {
    max-width: 180px;
    min-width: 180px;
  }
  .col-activation {
    max-width: 275px !important;
    min-width: 275px !important;;
  }
  .col-duration-type {
    min-width: 200px !important;;
    max-width: 200px !important;;
  }
  .col-end-date {
    max-width: 150px;
    min-width: 150px;
  }
  .col-status {
    max-width: 240px;
    min-width: 240px;
  }
  .col-transaction {
    max-width: 180px;
    min-width: 180px;
  }
  .col-action {
    max-width: 80px;
  }
</style>

<style lang="scss">
  .text-field fieldset {
    background: #fff !important;
  }
  .text-search {
    .v-input__slot {
      min-height: 20px !important;
      padding-left: 35px !important;
    }
  }

  .cursor-pointer {
    cursor: pointer;
  }
  .pick-date-custom {
    input{
      height: 40px;
      border: 1px solid #9E9E9E;
    }
  }

</style>
